import $ from 'jquery';

import { Feedback, Send } from '@openculinary/jquery-feedback/dist/feedback';
import '@openculinary/jquery-feedback/examples/css/feedback.css';

import './bootstrap-overrides.css';

class JSONAdapter extends Send {
  constructor(url) {
    super();
    this.url = url;
  }

  send(data, callback) {
    $.post({
      url: this.url,
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: function() { callback(true) },
      error: function() { callback(false) }
    });
  }
};

$(function() {
  Feedback({
    h2cPath: 'html2canvas.js',
    url: '/api/feedback',
    scrollX: 0,
    scrollY: 0,
    scale: 1,
    redactions: false,
    adapter: new JSONAdapter('/api/feedback'),
    browserInfo: {
      url: true,
      browserVersion1b: true,
      browserLanguage: true,
      sizeInW: true,
      sizeInH: true
    }
  });
});
